export const convertFileToBase64 = (file: File): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
        fileReader.readAsDataURL(file);
    });
};
export function convertBase64ToUnicode(base64String: string) {
    return decodeURIComponent(
        atob(base64String)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );
}
export function convertUnicodeToBase64(unicodeString: string) {
    return btoa(
        encodeURIComponent(unicodeString).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt("0x" + p1));
        })
    );
}
